import axios from "axios";

export const api = axios.create({
  baseURL: "https://portal.trtexpress.com/api/",
  //baseURL: "https://portal-dev.trtexpress.com/api/",
  //baseURL: "https://localhost:5001/api/",
  headers: {"Accept": "*/*", "Content-Type": "application/json"},
  timeout: 5000,
});


export const getToken = () => {
  const username = "kegax27028@byorby.com";
  const password = "Password123!";
  return api.post("Token", {
    "email": username,
    "password": password,
    "grantType": "password",
    "rememberMe": true,
  });
};

export const getTrackingInfo = (trackingNumber: string) => {
  return api.get(`organizations/1/tracking?trackingNumber=${trackingNumber}`);
};




